import recorderClass from "./components/recorder";
import { handleMobileUsers } from "./utils/handleMobileUsers";

window.addEventListener("load", () => handleMobileUsers());

const screenRec = {};
//instance
screenRec.recorder = new recorderClass();
// init
screenRec.recorder.init();
